function initImageWithIcon() {
  if (!gsap || !ScrollTrigger) return;
  gsap.registerPlugin(ScrollTrigger);

  const containers = document.querySelectorAll('[data-image-with-icon]');
  if (!containers.length) return;

  containers.forEach((container) => {
    if (container.dataset.imageIconInit) return;
    container.dataset.imageIconInit = true;

    const mm = gsap.matchMedia();
    let currentTween;

    mm.add('(min-width: 1024px)', () => {
      ScrollTrigger.create({
        trigger: container,
        start: 'top top',
        end: 'bottom bottom',
        scrub: false,
        onUpdate: (self) => {
          const progress = self.progress;
          const top = gsap.utils.clamp(5, 70, 10 + progress * 80);

          if (currentTween) currentTween.kill();

          const icon = container.querySelector('.image-with-text__media-icon');
          if (icon) {
            currentTween = gsap.to(icon, {
              top: `${top}%`,
              duration: 0.9,
              ease: 'power3.out',
              overwrite: 'auto',
            });
          }
        },
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', initImageWithIcon);
document.addEventListener('shopify:section:load', initImageWithIcon);
document.addEventListener('shopify:section:unload', (event) => {
  const containers = event.target.querySelectorAll('[data-image-with-icon]');
  containers.forEach((container) => {
    container.dataset.imageIconInit = false;
    ScrollTrigger.getAll().forEach((st) => st.kill());
  });
});
